import type { InvoicedEntity } from '@/types/company';
import type { Option } from '@components/forms/GridSelect';

export const enum BillingType {
    CutFee = 0,
    NoCutFee = 1,
}

export const enum WarrantyType {
    Warranty = 0,
    NoWarranty = 1,
}

export const BILLING_OPTIONS: Option[] = [
    {
        label: 'Cut Fee',
        value: BillingType.CutFee,
    },
    {
        label: 'No Cut Fee',
        value: BillingType.NoCutFee,
    },
];

export const WARRANTY_OPTIONS: Option[] = [
    {
        label: 'Warranty',
        value: WarrantyType.Warranty,
    },
    {
        label: 'No Warranty',
        value: WarrantyType.NoWarranty,
    },
];

export const DEFAULT_BILLING_OPTIONS: InvoicedEntity = {
    CutPlanID: BillingType.CutFee,
    WarrantyPlanID: WarrantyType.Warranty,
};
